export default __webpack_public_path__ + "static/media/logo2.cb3848a6.png";